import { SET_FORM_STATE } from '../actions/GEOInputFileActions.js';

const initialState = {
	remove: []
};

const GEOFilesUploadReducer = (state = initialState, action) => {
	switch (action.type) {
					case SET_FORM_STATE: {
						return {
							...state,
							remove: action.remove
						};
					}
					default: {
						return state;
					}
	}
};

export default GEOFilesUploadReducer;
